import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-gray-600 dark:text-gray-300 mb-6" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorState',
  props: {
    error: {}
  },
  emits: ['back-to-home'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("svg", {
        class: "w-16 h-16 mx-auto mb-4 text-gray-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
        })
      ], -1)),
      _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-2xl font-bold text-gray-900 dark:text-white mb-2" }, "Wallpaper Not Found", -1)),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.error || 'The requested wallpaper could not be found.'), 1),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back-to-home'))),
        class: "px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-semibold transition-colors"
      }, " Back to Home ")
    ])
  ]))
}
}

})